var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "candidate-navbar",
        staticStyle: { "background-color": "#3b425d" },
      },
      [
        _c(
          "a",
          {
            staticStyle: { "background-color": "#22c59a", color: "#fff" },
            attrs: { type: "button", href: "javascript:void(0)" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openOnBoardModal()
              },
            },
          },
          [_vm._v(" 確認報到 ")]
        ),
        _c(
          "a",
          {
            attrs: { type: "button", href: "javascript:void(0)" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$router.go(-1)
              },
            },
          },
          [_vm._v("返回")]
        ),
      ]
    ),
    _c(
      "div",
      { staticClass: "step-page" },
      [
        _c(
          "h3",
          { staticClass: "mb-3 text-center", staticStyle: { color: "#fff" } },
          [_vm._v("報到資料")]
        ),
        _c(
          "ValidationObserver",
          { ref: "observer" },
          [
            _c(
              "el-tabs",
              {
                staticClass: "tab-component",
                attrs: { "tab-position": "left" },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "圖檔繳交", name: "圖檔繳交" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "step-content",
                        staticStyle: { background: "transparent" },
                      },
                      [
                        _c("Images", {
                          key: _vm.key,
                          attrs: { MatchId: _vm.MatchId },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm.showIncomeTaxReturn
                  ? _c(
                      "el-tab-pane",
                      {
                        key: "incomeTax",
                        attrs: { label: "免稅額申報表", name: "免稅額申報表" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "step-content",
                            staticStyle: { background: "white" },
                          },
                          [_c("IncomeTax")],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._l(_vm.contracts, function (item, index) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: item.ContractVersionGuid,
                      attrs: {
                        label: item.ContractName,
                        name: item.ContractName,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "step-content",
                          staticStyle: { background: "#fff" },
                        },
                        [
                          _c("div", { staticStyle: { padding: "15px" } }, [
                            _c("div", { staticClass: "contract-title" }, [
                              _vm._v(_vm._s(item.ContractTitle)),
                            ]),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(item.ContractContent),
                              },
                            }),
                            _c("table", { staticClass: "w-100" }, [
                              _c("tr", [
                                _c("th", { attrs: { id: "date" } }, [
                                  _vm._v("簽署日期"),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.SignedTime
                                          ? _vm.$common.dateFormatter(
                                              item.SignedTime
                                            )
                                          : _vm.$common.getToday()
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                              _c("tr", [
                                _c("td", { staticStyle: { width: "112px" } }, [
                                  _vm._v("簽章"),
                                ]),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.SignedPicBase64,
                                        expression: "item.SignedPicBase64",
                                      },
                                    ],
                                    attrs: { colspan: "3" },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "400px",
                                        height: "200px",
                                        border: "2px solid rgb(215, 215, 215)",
                                      },
                                      attrs: {
                                        src: item.SignedPicBase64,
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.resigned(index)
                                          },
                                        },
                                      },
                                      [_vm._v("重簽")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.SignedPicBase64,
                                        expression: "!item.SignedPicBase64",
                                      },
                                    ],
                                    attrs: { colspan: "3" },
                                  },
                                  [
                                    _c("VueSignature", {
                                      ref: `signature${index}`,
                                      refInFor: true,
                                      staticClass: "signaturePad",
                                      staticStyle: {
                                        border: "2px solid #d7d7d7",
                                      },
                                      attrs: {
                                        id: `signature${index}`,
                                        defaultUrl: item.SignedPicBase64 || "",
                                        w: "400px",
                                        h: "200px",
                                      },
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clear(index)
                                          },
                                        },
                                      },
                                      [_vm._v("清除")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "mt-2",
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadPDF(
                                          item.ContractVersionGuid
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 下載 PDF ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "mt-2 save-btn",
                                    attrs: { size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveContract(index)
                                      },
                                    },
                                  },
                                  [_vm._v(" 儲存 ")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "checkOnBoardModal",
          tabindex: "-1",
          "data-backdrop": "static",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog" },
          [
            _c("img", {
              staticClass: "cord",
              attrs: {
                src: require("@/assets/img/name_card_cord.png"),
                alt: "",
              },
            }),
            _c("ValidationObserver", {
              ref: "reported",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "modal-content" }, [
                            _c("div", { staticClass: "modal-header" }, [
                              _c("span", [_vm._v("完成報到")]),
                            ]),
                            _c("div", { staticClass: "modal-body" }, [
                              _c("div", { staticClass: "info" }, [
                                _c("div", { staticClass: "text-wrap" }, [
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v(_vm._s(_vm.person.Name)),
                                  ]),
                                  _c("div", { staticClass: "position" }, [
                                    _vm._v(_vm._s(_vm.person.Position)),
                                  ]),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "state-wrap" },
                                [
                                  _c("ValidationProvider", {
                                    staticClass: "w-100",
                                    attrs: { tag: "div", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.person
                                                            .OnBoardStatus,
                                                        expression:
                                                          "person.OnBoardStatus",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: 0,
                                                      checked: _vm._q(
                                                        _vm.person
                                                          .OnBoardStatus,
                                                        0
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.person,
                                                          "OnBoardStatus",
                                                          0
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: { for: "" },
                                                    },
                                                    [_vm._v(" 待報到 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.person
                                                            .OnBoardStatus,
                                                        expression:
                                                          "person.OnBoardStatus",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: 1,
                                                      checked: _vm._q(
                                                        _vm.person
                                                          .OnBoardStatus,
                                                        1
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.person,
                                                          "OnBoardStatus",
                                                          1
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: { for: "" },
                                                    },
                                                    [_vm._v(" 完成報到 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.person
                                                            .OnBoardStatus,
                                                        expression:
                                                          "person.OnBoardStatus",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: -99,
                                                      checked: _vm._q(
                                                        _vm.person
                                                          .OnBoardStatus,
                                                        -99
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.person,
                                                          "OnBoardStatus",
                                                          -99
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: { for: "" },
                                                    },
                                                    [_vm._v(" 取消報到 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check form-check-inline",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.person
                                                            .OnBoardStatus,
                                                        expression:
                                                          "person.OnBoardStatus",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: -1,
                                                      checked: _vm._q(
                                                        _vm.person
                                                          .OnBoardStatus,
                                                        -1
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.person,
                                                          "OnBoardStatus",
                                                          -1
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: { for: "" },
                                                    },
                                                    [_vm._v(" 延期報到 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "text-danger",
                                                  staticStyle: {
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm.person.OnBoardStatus === 1 ||
                              _vm.person.OnBoardStatus === -1
                                ? _c(
                                    "div",
                                    { staticClass: "number-wrap" },
                                    [
                                      _c("ValidationProvider", {
                                        staticClass: "w-100",
                                        attrs: {
                                          tag: "div",
                                          rules: "required",
                                          name: "報到日期",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("el-date-picker", {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      type: "date",
                                                      "value-format":
                                                        "yyyy-MM-dd",
                                                      "picker-options": {
                                                        disabledDate:
                                                          _vm.$common
                                                            .disabledDateBeforeToday,
                                                      },
                                                      placeholder: "請選擇日期",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.person
                                                          .NewOnBoardDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.person,
                                                          "NewOnBoardDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "person.NewOnBoardDate",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                      staticStyle: {
                                                        "font-size": "13px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm.person.OnBoardStatus === -99
                                ? _c(
                                    "div",
                                    [
                                      _c("ValidationProvider", {
                                        staticClass: "w-100",
                                        attrs: {
                                          tag: "div",
                                          rules: "required",
                                          name: "原因",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("el-cascader", {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      options:
                                                        _vm.notArrivedCategoryOptions,
                                                      clearable: "",
                                                      "show-all-levels": true,
                                                      placeholder: "請選擇原因",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.person
                                                          .notArrivedCategory,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.person,
                                                          "notArrivedCategory",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "person.notArrivedCategory",
                                                    },
                                                  }),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                      staticStyle: {
                                                        "font-size": "13px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.person.OnBoardRemark,
                                            expression: "person.OnBoardRemark",
                                          },
                                        ],
                                        staticClass: "form-control w-100",
                                        attrs: {
                                          type: "text",
                                          rows: "3",
                                          maxlength: "200",
                                          placeholder: "請輸入備註",
                                        },
                                        domProps: {
                                          value: _vm.person.OnBoardRemark,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.person,
                                              "OnBoardRemark",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _c("div", { staticClass: "modal-footer" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: {
                                    type: "reset",
                                    "aria-label": "關閉",
                                    "data-dismiss": "modal",
                                  },
                                },
                                [_vm._v(" 取消 ")]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return handleSubmit(_vm.confirmedOnBoard)
                                    },
                                  },
                                },
                                [_vm._v(" 確認 ")]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }